import Vue from 'vue';
import Vuex from 'vuex';

import navigation from './modules/navigation';
import application from './modules/application-state';
import cms from './modules/cms-view';
import cart from './modules/cart';
import products from './modules/products';
import userInfo from './modules/user-info';
import orderTracking from './modules/order.js';
import threeDFiles from './modules/three-d-models';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        navigation,
        application,
        cms,
        cart,
        products,
        userInfo,
        orderTracking,
        threeDFiles,
    },
    strict: true,
});
